import { FieldRule, RuleContext } from '../type';

/**
 *
 * @param rules
 * @returns
 */
export function composeRules<T>(...rules: FieldRule<T>[]) {
    const ordered = [...rules].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    return (value: string, ctx: RuleContext<T>) => {
        for (const r of ordered) {
            if (r.when && !r.when(ctx)) {
                continue;
            }

            const res = r.validate(value, ctx);
            if (res !== true) {
                return res;
            }
        }
        return true;
    };
}
